import React from 'react'

export const TextLink: React.FC<{ text: string; onClick: () => void }> = ({
  text,
  onClick,
}) => (
  // eslint-disable-next-line jsx-a11y-x/anchor-is-valid
  <a
    href="#"
    style={{
      cursor: 'pointer',
      textDecoration: 'underline',
    }}
    onClick={(e) => {
      e.preventDefault()
      onClick()
    }}
  >
    {text}
  </a>
)
